import { buildAppVersion } from '@st/util/app-version'
import { Context, Layer } from 'effect'
import type { AppType } from '~/features/app-type'
import { envVar, FEATURE_FLAGS } from '~/env'

export type AppRuntimeConfigInput = {
  appType: AppType
  browserOrigin: string
  devMode: boolean
}

export type RuntimeConfigService = {
  appType: AppType
  devMode: boolean
  apiBaseUrl: string
  browserOrigin: string
  socketEndpoint: string
  pushTaxReturn: boolean
  clientVersion: string | null
}

export class RuntimeConfig extends Context.Service<RuntimeConfig, RuntimeConfigService>()(
  'RuntimeConfig'
) {}

export function runtimeConfigLayer(config: AppRuntimeConfigInput) {
  const apiBaseUrl = envVar('NEXT_PUBLIC_API_V2_ENDPOINT')!
  const socketEndpoint = httpToWebSocket(apiBaseUrl)
  const clientVersion =
    buildAppVersion(envVar('NEXT_PUBLIC_BUILD_TIME'), envVar('NEXT_PUBLIC_BUILD_SHA')) ?? null

  return Layer.succeed(RuntimeConfig, {
    appType: config.appType,
    devMode: config.devMode,
    apiBaseUrl,
    browserOrigin: config.browserOrigin,
    socketEndpoint,
    clientVersion,
    pushTaxReturn: FEATURE_FLAGS.pushTaxReturn
  })
}

function httpToWebSocket(httpUrl: string) {
  const url = new URL(httpUrl)
  if (url.protocol == 'http:') {
    url.protocol = 'ws:'
    url.pathname = '/socket/websocket'
  } else if (url.protocol == 'https:') {
    url.protocol = 'wss:'
    url.pathname = '/socket/websocket'
  }
  return url.toString()
}
